
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mavzuli-test/[subject]/[testId]",
      function () {
        return require("private-next-pages/mavzuli-test/[subject]/[testId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mavzuli-test/[subject]/[testId]"])
      });
    }
  